import { SITE } from "@/constants/testIds";

const IMG =
  "https://images.unsplash.com/photo-1601379327279-44b026715787?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxzaW5nbGUlMjBjYW5kbGUlMjBkYXJrJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3ODA5MzE5NjZ8MA&ixlib=rb-4.1.0&q=85";

export const Story = () => {
  return (
    <section
      id="story"
      data-testid={SITE.storySection}
      className="relative py-24 sm:py-32 bg-background"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src={IMG}
              alt="A single Shabbat candle burning in the dark"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background via-background/10 to-transparent" />
          </div>
          <p className="mt-4 text-xs uppercase tracking-[0.28em] text-foreground/40">
            We light the candle. We remember.
          </p>
        </div>

        <div className="lg:col-span-7">
          <p className="text-xs uppercase tracking-[0.32em] text-primary/90 mb-5">
            The Story Behind the Song
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-foreground leading-[1.05] tracking-tight text-balance">
            A song that began
            <br />
            as <span className="italic text-primary">gratitude</span>.
          </h2>

          <div className="gold-rule w-24 my-8" />

          <div className="space-y-6 text-foreground/80 text-base sm:text-lg leading-relaxed max-w-2xl">
            <p>
              The song began as an expression of gratitude.{" "}
              <span className="text-foreground">Polina Rachel Furman&apos;s</span>{" "}
              grandfather, <span className="text-foreground">Vladimir Furman</span>,
              was a Soviet refusenik who immigrated to the United States with his
              family after years of being denied permission to leave the USSR.
            </p>
            <p>
              The project reflects gratitude for freedom, Jewish life, family
              legacy, and the opportunities America provided — a quiet table, a
              candle lit on Friday night, a country that let his family come
              home.
            </p>
            <p>
              And it asks a question: what responsibility does the next
              generation have to carry that light forward?
            </p>
          </div>

          <p className="mt-10 font-serif italic text-foreground/55 text-sm">
            — Words and music by Polina Rachel Furman
          </p>
        </div>
      </div>
    </section>
  );
};
